import { createSelector } from 'reselect';

import { EUserType } from '../PageAuth/constants/authConstants';
import { subscriberIdApi } from './store';


/*
* -------------------------------------------
*               Api
* -------------------------------------------
*/

const subscriberIdApiSelector = (subscriberId: string, userType: EUserType) =>
    subscriberIdApi.endpoints.getSubscriberIdMeta.select({ subscriberId, userType });

export const subscriberIdAccountSelector = (subscriberId: string, userType: EUserType) => createSelector(
    subscriberIdApiSelector(subscriberId, userType),
    dcRules => dcRules.data?.account,
);

export const subscriberIdRegionSelector = (subscriberId: string, userType: EUserType) => createSelector(
    subscriberIdApiSelector(subscriberId, userType),
    dcRules => dcRules.data?.region,
);

export const subscriberIdRegionIdSelector = (subscriberId: string, userType: EUserType) => createSelector(
    subscriberIdApiSelector(subscriberId, userType),
    dcRules => dcRules.data?.regionId,
);

export const subscriberIdNumberSelector = (subscriberId: string, userType: EUserType) => createSelector(
    subscriberIdApiSelector(subscriberId, userType),
    dcRules => dcRules.data?.number ?? '',
);

export const subscriberIdNameSelector = (subscriberId: string, userType: EUserType) => createSelector(
    subscriberIdApiSelector(subscriberId, userType),
    dcRules => dcRules.data?.name ?? '',
);

export const subscriberIdServiceCategoryIdSelector = (subscriberId: string, userType: EUserType) => createSelector(
    subscriberIdApiSelector(subscriberId, userType),
    dcRules => dcRules.data?.servicesCategoryId,
);

export const subscriberIdAccessPointsSelector = (subscriberId: string, userType: EUserType) => createSelector(
    subscriberIdApiSelector(subscriberId, userType),
    dcRules => dcRules.data?.accessPoints,
);

export const subscriberIdUserTypeSelector = (subscriberId: string, userType: EUserType) => createSelector(
    subscriberIdApiSelector(subscriberId, userType),
    dcRules => dcRules.data?.userType,
);
